import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';
import { BILLING_INFO_KEY } from 'queries/useBillingInfos';

export type BankTransferType = 'bank_transfer' | 'administrative_order';

interface InitBankTransferPaymentPayload {
  products: {
    essentiel?: number;
    integral?: number;
  };
  paymentMethod: BankTransferType;
}

export function useCreatePaymentIntent() {
  const queryClient = useQueryClient();
  const { notifyError } = useNotification();
  const { t } = useTranslation(['userSettings']);

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (payload: InitBankTransferPaymentPayload) =>
      request('/billing/payment-intent', {
        method: 'POST',
        body: payload,
      }),
    onError: () => {
      notifyError({
        title: t('userSettings:notifications.paymentInitializationFailed'),
      });
    },
    onSuccess: () => {
      // reload payment history
      queryClient.invalidateQueries({
        queryKey: [BILLING_INFO_KEY],
      });
    },
  });

  return {
    mutateAsync,
    isPending,
  };
}
